import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';

@Component({
  selector: 'input-label',
  template: ` <div class="control-v2-title mb-2" [ngClass]="customClass()">
    {{ label }}{{ required ? '*' : '' }}
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputLabelComponent {
  @Input() label: string;
  @Input() required: boolean = false;

  customClass = input<string>();
}
